export const CREATE_AUTRE = "CREATE_AUTRE";
export const RETRIEVE_AUTRES = "RETRIEVE_AUTRES";
export const UPDATE_AUTRE = "UPDATE_AUTRE";
export const DELETE_AUTRE = "DELETE_AUTRE";
export const DELETE_ALL_AUTRES = "DELETE_ALL_AUTRES";
